/**
 * Filmproduktionen Renderer
 * Renders the film productions grid
 */

import type { FilmproduktionenData, StolpersteineData } from '../../types';

export function renderFilmproduktionen(
  data: FilmproduktionenData | null,
  stolpersteineData: StolpersteineData | null
): void {
  const container = document.getElementById('filmproduktionen-grid');
  if (!container || !data) return;

  const stolpersteine = stolpersteineData?.stolpersteine ?? [];

  const html = data.produktionen.map(film => {
    const stolperstein = stolpersteine.find(s => s.filmproduktion_ids?.includes(film.id));
    return `
    <article class="film-card">
      <a href="filmproduktion/${film.slug}.html" class="film-card__thumbnail">
        <img src="${film.vorschaubild}" alt="${film.titel}" loading="lazy">
        <span class="film-card__play-btn" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M8 5v14l11-7z"/>
          </svg>
        </span>
      </a>
      <h4 class="film-card__title">
        <a href="filmproduktion/${film.slug}.html">${film.titel}</a>
      </h4>
      ${stolperstein ? `
        <p class="film-card__subtitle">${stolperstein.name}</p>
      ` : ''}
    </article>
  `;
  }).join('');

  container.innerHTML = html;
}
